import React from 'react';
import { RefreshCwIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { MonthCalendar } from '../../components/shared/MonthCalendar';
import { Button } from '../../components/ui/Button';
export function MemberCalendar() {
  const {
    currentMember,
    visibleEvents,
    today,
    pushToast
  } = useApp();
  const me = currentMember!;
  return <div className="space-y-5" data-id="element-1387" data-mp="yxrpl5a7qmpi">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-1388" data-mp="1mp5gr7wmoc8w">
        <div data-id="element-1389" data-mp="1rorwpp3uc6le">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-1390" data-mp="1roi55x35drdl">Koledar</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1391" data-mp="1rmp6b3ys0bg5">Vaje in nastopi, ki se nanašajo na vas.</p>
        </div>
        <Button variant="secondary" onClick={() => pushToast('Povezava za sinhronizacijo je bila pripravljena.')} data-id="element-1392" data-mp="1hqlwdbxon8in">
          <RefreshCwIcon className="h-4 w-4" data-id="element-1393" data-mp="1cly05ehjqxi" />
          Sinhronizacija koledarja
        </Button>
      </div>

      <MonthCalendar events={visibleEvents(me.id)} detailBase="/clan/dogodki" today={today} data-id="element-1394" data-mp="6bynyz0nle4b" />
    </div>;
}